import { productStatusOptions, ProductStatusT } from "src/pages/product/product-types";

const ProductStatusLabel = ({ status }: { status: ProductStatusT }) => {
  return (
    <div>
      <span>{productStatusOptions.find((option) => option.value === status)?.label || ""}</span>
    </div>
  );
};
export default ProductStatusLabel;
